import clsx from 'clsx';
import BasicImage from 'core/BasicImage';
import ScrollAnimation from 'core/ScrollAnimation';
import { sanitize } from 'isomorphic-dompurify';
import Image from 'next/image';
import React from 'react';

import cn from './style.module.sass';

type CertificatesCardProps = {
    img: string;
    name: string;
    link?: string;
    direction?: string;
    isLessThanEight?: boolean;
    isSolution?: boolean;
};

export default function SiteCardFilter({
    img,
    name,
    link,
    direction,
    isLessThanEight = false,
    isSolution,
}: CertificatesCardProps) {
    let isLess = '';
    if (isLessThanEight) {
        isLess = cn['certificates__item--less'] as string;
    }

    return (
        <ScrollAnimation isSlideUp={true} className={clsx(cn['certificates__item'], isLess)}>
            <a href={link} className={cn['certificates__link']}>
                <div className={cn['certificates__top']}>
                    {direction && <div className={cn['certificates__direction']}>{direction}</div>}
                    <div className={cn['certificates__img']}>
                        {isSolution ? (
                            <Image
                                width={0}
                                height={0}
                                sizes="100vw"
                                style={{ width: '100%', height: 'auto' }} // optional
                                src={img}
                                alt={name}
                            />
                        ) : (
                            <BasicImage
                                width={0}
                                height={0}
                                sizes="100vw"
                                style={{ width: '100%', height: 'auto' }} // optional
                                src={img}
                                alt={name}
                            />
                        )}
                    </div>
                </div>
                {direction ? (
                    <div
                        dangerouslySetInnerHTML={{ __html: sanitize(name) }}
                        className={cn['certificates__name']}
                    />
                ) : (
                    <div
                        dangerouslySetInnerHTML={{ __html: sanitize(name) }}
                        className={cn['certificates__name-black']}
                    />
                )}
            </a>
        </ScrollAnimation>
    );
}
